import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useMemo, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import PremiumBusinessCard from "../pages/connectingHindu/BusinessCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation, Pagination } from "swiper/modules";
import { useItemCategoryData } from "../hooks/useItemCategoryData";
import { ConnectCard1 } from "./subComponents/ConnectCard1";
import ConnectCard2 from "./subComponents/ConnectCard2";
import ConnectBanner from "./subComponents/ConnectBanner";
import NewsSwiper from "./swipper/NewsSwiper";
import VideoSwiper from "./swipper/VideoSwiper";
import { saffronRout, saffronURL } from "../Url";

const safeArray = (v) => (Array.isArray(v) ? v : []);
const addPosition = (arr) =>
  safeArray(arr).map((item, i) => ({ ...item, position: i }));

const CONTENT_MAP = {
  latest_news: { listKey: "latest_news" },
  trend_news: { listKey: "trend_news" },
  featured_news: { listKey: "featured_news" },
  trend_video: { listKey: "trend_video" },
  latest_video: { listKey: "latest_video" },
  featured_video: { listKey: "featured_video" },
  audio: { listKey: "trend_audio" },
  quotes: { listKey: "home_quotes" },
  blog: { listKey: "blogs" },
  ebook: { listKey: "ebooks" },
  feature: { listKey: "home_features" },
  listing: { listKey: "Home_listingsBusiness" },
  popularProfiles: { listKey: "popularProfiles" },
};

const keepKeys = ["country", "state", "city", "language", "category"];

const buildSectionSearch = (location, sectionKey) => {
  const current = new URLSearchParams(location?.search);
  const next = new URLSearchParams();

  keepKeys.forEach((k) => {
    const v = current.get(k);
    if (v !== null && v !== "") next.set(k, v);
  });

  if (sectionKey) next.set("section", sectionKey);

  return `?${next.toString()}`;
};




const SingleBannerTree = ({
  selectedCountry,
  selectedCategory,
  selectedLanguage,
  selectedState,
  selectedCity,
  api = "https://thehindutoday.com",
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryConfig = {
  retry: false,
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
   keepPreviousData: true
};


  const { data: getNew = [] } = useQuery({
    queryKey: [
      "getNewss",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_trending", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-news?${params.toString()}`,
      );
      return res.data;
    },
   ...queryConfig
  });

  const { data: getVideo = [] } = useQuery({
    queryKey: [
      "is_video_trend",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_trending", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-videos?${params.toString()}`,
      );
      return res.data;
    },
    ...queryConfig

  });
    const { data: latestVideo = [] } = useQuery({
    queryKey: [
      "is_video_latest",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_latest", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-videos?${params.toString()}`,
      );
      return res.data;
    },
       ...queryConfig

  });
   const { data: featuredVideo = [] } = useQuery({
    queryKey: [
      "is_video_featured",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-videos?${params.toString()}`,
      );
      return res.data;
    },
      ...queryConfig

  });

  const { data } = useItemCategoryData({
    key: "connect_quote",
    endpoint: "quotes",
    selectedCategory,
    selectedCountry,
    selectedLanguage,
    selectedState,
    selectedCity,
    enabled: true,
    mianURL: saffronURL,
  });

  const { data: audio = [] } = useQuery({
    queryKey: [
      "is_audio",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-audios?${params.toString()}`,
      );
      return res.data;
    },
    ...queryConfig

  });

  const { data: latest_news = [] } = useQuery({
    queryKey: [
      "latest_news",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_latest", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-news?${params.toString()}`,
      );
      return res.data;
    },
     ...queryConfig

  });

  const { data: featured_news = [] } = useQuery({
    queryKey: [
      "is_featured_news",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-news?${params.toString()}`,
      );
      return res.data;
    },
    ...queryConfig

  });

  const { data: apiblogsData = [] } = useQuery({
    queryKey: [
      "apiblogsData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      params.append("limit", 9);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-blogs?${params.toString()}`,
      );
      return res.data;
    },
      ...queryConfig

  });

  const { data: feature_only = [] } = useQuery({
    queryKey: [
      "feature_only",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      params.append("limit", 9);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-stories?${params.toString()}`,
      );
      return res.data;
    },
    ...queryConfig

  });

  const { data: ebook = [] } = useQuery({
    queryKey: [
      "ebook",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      params.append("limit", 9);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-ebooks?${params.toString()}`,
      );
      return res.data;
    },
     ...queryConfig

  });

  const { data: featureListData = [] } = useQuery({
    queryKey: [
      "featureListData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-listing?${params.toString()}`,
      );
      return res.data;
    },
   ...queryConfig

  });

  const { data: profiledata = [] } = useQuery({
    queryKey: [
      "profiledata",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      params.append("is_featured", 1);
      const res = await axios.get(
        `${api}/api/v1/public/get-feature-people?${params.toString()}`,
      );
      return res.data;
    },
     ...queryConfig

  });

  const { data: getTitleData = [] } = useQuery({
    queryKey: [
      "getTitleData",
      selectedCountry,
      selectedCategory,
      selectedLanguage,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);
      const res = await axios.get(
        `${api}/api/v1/public/get-header-title?${params.toString()}`,
      );
      return res.data?.data?.header_items;
    },
   ...queryConfig

  });

  // ✅ Positioned lists
  const trend_news = useMemo(() => addPosition(getNew?.data), [getNew?.data]);
  const trend_video = useMemo(
    () => addPosition(getVideo?.data),
    [getVideo?.data],
  );
  const latest_video = useMemo(
    () => addPosition(latestVideo?.data),
    [latestVideo?.data],
  );
   const featured_video = useMemo(
    () => addPosition(featuredVideo?.data),
    [featuredVideo?.data],
  );

  const get_quotes = useMemo(() => addPosition(data?.data?.quotes), [data]);
  const get_audio = useMemo(() => addPosition(audio?.data), [audio?.data]);
  const get_latest_news = useMemo(
    () => addPosition(latest_news?.data),
    [latest_news?.data],
  );
  const get_featured_news = useMemo(
    () => addPosition(featured_news?.data),
    [featured_news?.data],
  );
  const blogsData = useMemo(
    () => addPosition(apiblogsData?.data),
    [apiblogsData?.data],
  );
  const get_feature_only = useMemo(
    () => addPosition(feature_only?.data),
    [feature_only?.data],
  );
  const get_ebook = useMemo(() => addPosition(ebook?.data), [ebook?.data]);
  const popularCats = useMemo(
    () => addPosition(profiledata?.data),
    [profiledata?.data],
  );
  const allListings = useMemo(
    () => addPosition(featureListData?.data),
    [featureListData?.data],
  );

  /** ✅ Universal click → route navigation */
  const handleArticleClick = (item, type) => {
 
    const sectionKey = CONTENT_MAP[type]?.listKey;
    const slug = item?.slug || item?.id;
  
    if (!sectionKey || !slug) return;

    navigate(
      {
        pathname: `${saffronRout}/details/${type}/${slug}`,
        search: buildSectionSearch(location, sectionKey),
      },
      {
        state: {
          sectionKey,
          position: item?.position ?? 0,
          label: item?.title || item?.name || "Details",
        },
      },
    );

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const quotesPrevRef = useRef(null);
  const quotesNextRef = useRef(null);
  const audioPrevRef = useRef(null);
  const audioNextRef = useRef(null);
  const blogPrevRef = useRef(null);
  const blogNextRef = useRef(null);
  const feature_onlyPrevRef = useRef(null);
  const feature_onlyNextRef = useRef(null);
  const ebookPrevRef = useRef(null);
  const ebookNextRef = useRef(null);
  const profilePrevRef = useRef(null);
  const profileNextRef = useRef(null);
  const listingPrevRef = useRef(null);
  const listingNextRef = useRef(null);

  const NEWS_TABS = [
    { key: "trend", label: getTitleData?.[1]?.label },
    { key: "latest", label: getTitleData?.[4]?.label },
    { key: "featured", label: getTitleData?.[5]?.label },
  ];
  const video_TABS = [
    { key: "trend", label: getTitleData?.[0]?.label },
    { key: "latest", label: "Latest Videos" },
    { key: "featured", label: "Featured Videos" },
  ];

  const [newsTab, setNewsTab] = useState("trend");
  const [videoTab, setVideoTab] = useState("trend");

  const newsMap = {
    trend: trend_news || [],
    latest: get_latest_news || [],
    featured: get_featured_news || [],
  };
  const videosMap = {
    trend: trend_video || [],
    latest: latest_video || [],
    featured: featured_video || [],
  };


  const activeNews = newsMap[newsTab] || [];
  const activeVideo = videosMap[videoTab] || [];

  return (
    <>
      <ConnectBanner
        selectedCategory={selectedCategory}
        selectedCountry={selectedCountry}
        selectedLanguage={selectedLanguage}
        selectedState={selectedState}
        selectedCity={selectedCity}
      />

      <section className=" px-1 md:px-5 lg:px-10 bg-gradient-to-b from-[#fff0e4] to-[#fff0e4] space-y-3 pb-4">
        <div className="grid grid-cols-12 gap-5 items-stretch !mt-6">
          {(trend_video?.length > 0 || latest_video?.length > 0 || featured_video?.length > 0 )&& (
            <div className="col-span-12 lg:col-span-7 xl:col-span-8 h-full">
              <SectionWrapper
                location={location}
                className="h-full flex flex-col"
              >
                {/* Tabs row with bottom line */}
                <div className="">
                  <div className="flex gap-1">
                    {video_TABS.map((t) => {
                      const active = videoTab === t.key;

                      return (
                        <button
                          key={t.key}
                          onClick={() => setVideoTab(t.key)}
                          className={[
                            " px-2 md:px-4 xl:px-3 py-2 text-[12px] xl:text-[13px]  font-semibold transition-all duration-200",
                            "rounded-t-lg border",
                            active
                              ? "bg-orange-500 text-white border-orange-500 border-b-orange-500 mb-0"
                              : "bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200 mb-1",
                          ].join(" ")}
                        >
                          {t.label}
                        </button>
                      );
                    })}
                  </div>
                </div>

              <div className="flex-1">
                  <VideoSwiper
                    data={activeVideo}
                    onClick={(item) =>
                      handleArticleClick(item, `${videoTab}_video`)
                    }
                  />
                </div>
              </SectionWrapper>
            </div>
          )}

          {(trend_news?.length > 0 ||
            get_latest_news?.length > 0 ||
            get_featured_news?.length > 0) && (
            <div className="col-span-12 lg:col-span-5 xl:col-span-4 h-full self-stretch">
              <SectionWrapper
                // title="News"
                location={location}
                className="h-full flex flex-col"
              >
                {/* Tabs */}
                <div className="flex gap-1">
                  {NEWS_TABS.map((t) => {
                    const active = newsTab === t.key;

                    return (
                      <button
                        key={t.key}
                        onClick={() => setNewsTab(t.key)}
                        className={[
                          " px-2 md:px-4 xl:px-3 py-2 text-[12px] xl:text-[13px]  font-semibold transition-all duration-200",
                          "rounded-t-lg border",
                          active
                            ? "bg-orange-500 text-white border-orange-500 border-b-orange-500 mb-0"
                            : "bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200 mb-1",
                        ].join(" ")}
                      >
                        {t.label}
                      </button>
                    );
                  })}
                </div>

                {/* Content */}
                <div className="flex-1">
                  <NewsSwiper
                    data={activeNews}
                    onClick={(item) =>
                      handleArticleClick(item, `${newsTab}_news`)
                    }
                  />
                </div>
              </SectionWrapper>
            </div>
          )}
        </div>

        {/* QUOTES / AUDIO / LATEST */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {get_quotes?.length > 0 && (
            <div className="rounded-2xl border border-orange-200 bg-orange-50/40 overflow-hidden">
              {/* top accent */}
              {/* <div className="h-1 bg-gradient-to-r from-orange-500 to-amber-400" /> */}

              <SectionWrapper
                title={getTitleData?.[2]?.label}
                location={location}
              >
                <div className="relative video-swiper group px-2 pb-2">
                  {/* arrows */}
                  <button
                    ref={quotesPrevRef}
                    className="swiper-btn-prev"
                    type="button"
                  >
                    <ChevronLeft size={22} strokeWidth={2.5} />
                  </button>
                  <button
                    ref={quotesNextRef}
                    className="swiper-btn-next"
                    type="button"
                  >
                    <ChevronRight size={22} strokeWidth={2.5} />
                  </button>

                  <Swiper
                    modules={[Navigation, Pagination]}
                    slidesPerView={1}
                    spaceBetween={16}
                    loop={get_quotes.length > 1}
                    navigation={{
                      prevEl: quotesPrevRef.current,
                      nextEl: quotesNextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = quotesPrevRef.current;
                      swiper.params.navigation.nextEl = quotesNextRef.current;
                    }}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      640: { slidesPerView: 1 },
                      1024: { slidesPerView: 1 },
                      1300: { slidesPerView: 2 },
                    }}
                    className="rounded-xl overflow-hidden"
                  >
                    {get_quotes.map((item) => (
                      <SwiperSlide key={item.id}>
                        <ConnectCard1
                          item={item}
                          onArticleClick={() =>
                            handleArticleClick(item, "quotes")
                          }
                          imgH=" h-[210px]"
                          objimg="object-fill"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </SectionWrapper>
            </div>
          )}

          {get_audio?.length > 0 && (
            <div className="rounded-2xl border border-orange-200 bg-orange-50/40 overflow-hidden">
              {/* top accent */}
              {/* <div className="h-1 bg-orange-300" /> */}

              <SectionWrapper
                title={getTitleData?.[3]?.label}
                location={location}
              >
                <div className="relative video-swiper group px-2 pb-2">
                  <button
                    ref={audioPrevRef}
                    className="swiper-btn-prev"
                    type="button"
                  >
                    <ChevronLeft size={22} strokeWidth={2.5} />
                  </button>
                  <button
                    ref={audioNextRef}
                    className="swiper-btn-next"
                    type="button"
                  >
                    <ChevronRight size={22} strokeWidth={2.5} />
                  </button>

                  <Swiper
                    modules={[Navigation, Pagination]}
                    slidesPerView={1}
                    spaceBetween={16}
                    loop={get_audio.length > 1}
                    navigation={{
                      prevEl: audioPrevRef.current,
                      nextEl: audioNextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = audioPrevRef.current;
                      swiper.params.navigation.nextEl = audioNextRef.current;
                    }}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      640: { slidesPerView: 1 },
                      1024: { slidesPerView: 1 },
                      1300: { slidesPerView: 2 },
                    }}
                    className="rounded-xl overflow-hidden"
                  >
                    {get_audio.map((item) => (
                      <SwiperSlide key={item.id}>
                        <ConnectCard1
                          item={item}
                          onArticleClick={() =>
                            handleArticleClick(item, "audio")
                          }
                          imgH=" h-[210px]"
                          objimg="object-fill"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </SectionWrapper>
            </div>
          )}
        </div>

        {/* BLOGS SWIPER */}
        <div>
          {blogsData?.length > 0 && (
            <SectionWrapper
              title={getTitleData?.[6]?.label}
              location={location}
            >
              <div className="relative video-swiper">
                <button
                  ref={blogPrevRef}
                  className="swiper-btn-prev"
                  type="button"
                >
                  <ChevronLeft size={22} strokeWidth={2.5} />
                </button>
                <button
                  ref={blogNextRef}
                  className="swiper-btn-next"
                  type="button"
                >
                  <ChevronRight size={22} strokeWidth={2.5} />
                </button>

                <Swiper
                  modules={[Navigation]}
                  slidesPerView={4}
                  slidesPerGroup={1}
                  spaceBetween={16}
                  loop={blogsData.length > 4}
                  navigation={{
                    prevEl: blogPrevRef.current,
                    nextEl: blogNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = blogPrevRef.current;
                    swiper.params.navigation.nextEl = blogNextRef.current;
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1180: { slidesPerView: 4 },
                  }}
                  className="rounded-2xl overflow-hidden"
                >
                  {blogsData.map((item) => (
                    <SwiperSlide key={item.id}>
                      <ConnectCard1
                        item={item}
                        onArticleClick={() => handleArticleClick(item, "blog")}
                        imgH=" h-[200px]"
                        objimg="object-fill"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </SectionWrapper>
          )}
        </div>

        {/* FEATURE STORIES */}
        <div>
          {get_feature_only?.length > 0 && (
            <SectionWrapper
              title={getTitleData?.[7]?.label}
              location={location}
            >
              <div className="relative video-swiper group">
                <button
                  ref={feature_onlyPrevRef}
                  className="swiper-btn-prev"
                  type="button"
                >
                  <ChevronLeft size={22} strokeWidth={2.5} />
                </button>
                <button
                  ref={feature_onlyNextRef}
                  className="swiper-btn-next"
                  type="button"
                >
                  <ChevronRight size={22} strokeWidth={2.5} />
                </button>

                <Swiper
                  modules={[Navigation]}
                  slidesPerView={4}
                  slidesPerGroup={1}
                  spaceBetween={16}
                  loop={get_feature_only.length > 4}
                  navigation={{
                    prevEl: feature_onlyPrevRef.current,
                    nextEl: feature_onlyNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl =
                      feature_onlyPrevRef.current;
                    swiper.params.navigation.nextEl =
                      feature_onlyNextRef.current;
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1180: { slidesPerView: 4 },
                  }}
                  className="rounded-2xl overflow-hidden"
                >
                  {get_feature_only.map((item) => (
                    <SwiperSlide key={item.id}>
                      <ConnectCard1
                        item={item}
                        onArticleClick={() =>
                          handleArticleClick(item, "feature")
                        }
                        imgH=" h-[200px]"
                        objimg="object-fill"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </SectionWrapper>
          )}
        </div>

        {/* EBOOK */}
        <div>
          {get_ebook?.length > 0 && (
            <SectionWrapper
              title={getTitleData?.[8]?.label}
              location={location}
            >
              <div className="relative video-swiper">
                <button
                  ref={ebookPrevRef}
                  className="swiper-btn-prev"
                  type="button"
                >
                  <ChevronLeft size={22} strokeWidth={2.5} />
                </button>
                <button
                  ref={ebookNextRef}
                  className="swiper-btn-next"
                  type="button"
                >
                  <ChevronRight size={22} strokeWidth={2.5} />
                </button>

                <Swiper
                  modules={[Navigation]}
                  slidesPerView={4}
                  slidesPerGroup={1}
                  spaceBetween={16}
                  loop={get_ebook.length > 4}
                  navigation={{
                    prevEl: ebookPrevRef.current,
                    nextEl: ebookNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = ebookPrevRef.current;
                    swiper.params.navigation.nextEl = ebookNextRef.current;
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1180: { slidesPerView: 4 },
                  }}
                  className="rounded-2xl overflow-hidden"
                >
                  {get_ebook.map((item) => (
                    <SwiperSlide key={item.id}>
                      <ConnectCard1
                        item={item}
                        onArticleClick={() => handleArticleClick(item, "ebook")}
                        // imgH=" h-[250px]"
                        objimg="object-fill"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </SectionWrapper>
          )}
        </div>

        {/* POPULAR PROFILES */}
        <div>
          {popularCats?.length > 0 && (
            <SectionWrapper
              title={getTitleData?.[9]?.label}
              location={location}
            >
              <div className="relative video-swiper">
                <button
                  ref={profilePrevRef}
                  className="swiper-btn-prev"
                  type="button"
                >
                  <ChevronLeft size={22} strokeWidth={2.5} />
                </button>
                <button
                  ref={profileNextRef}
                  className="swiper-btn-next"
                  type="button"
                >
                  <ChevronRight size={22} strokeWidth={2.5} />
                </button>

                <Swiper
                  modules={[Navigation]}
                  slidesPerView={4}
                  slidesPerGroup={1}
                  spaceBetween={16}
                  loop={popularCats.length > 4}
                  navigation={{
                    prevEl: profilePrevRef.current,
                    nextEl: profileNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = profilePrevRef.current;
                    swiper.params.navigation.nextEl = profileNextRef.current;
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1180: { slidesPerView: 4 },
                  }}
                  className="rounded-2xl overflow-hidden"
                >
                  {popularCats.map((item) => (
                    <SwiperSlide key={item.id}>
                      <ConnectCard2
                        data={item}
                        onArticleClick={() =>
                          handleArticleClick(item, "popularProfiles")
                        }
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </SectionWrapper>
          )}
        </div>

        {/* LISTINGS */}
        <div>
          {allListings?.length > 0 && (
            <SectionWrapper
              title={getTitleData?.[10]?.label}
              location={location}
            >
              <div className="relative video-swiper">
                <button
                  ref={listingPrevRef}
                  className="swiper-btn-prev"
                  type="button"
                >
                  <ChevronLeft size={22} strokeWidth={2.5} />
                </button>
                <button
                  ref={listingNextRef}
                  className="swiper-btn-next"
                  type="button"
                >
                  <ChevronRight size={22} strokeWidth={2.5} />
                </button>

                <Swiper
                  modules={[Navigation]}
                  slidesPerView={4}
                  slidesPerGroup={1}
                  spaceBetween={16}
                  loop={allListings.length > 4}
                  navigation={{
                    prevEl: listingPrevRef.current,
                    nextEl: listingNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = listingPrevRef.current;
                    swiper.params.navigation.nextEl = listingNextRef.current;
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1180: { slidesPerView: 4 },
                  }}
                  className="rounded-2xl overflow-hidden"
                >
                  {allListings.map((item) => (
                    <SwiperSlide key={item.id}>
                      <PremiumBusinessCard
                        data={item}
                        onArticleClick={() =>
                          handleArticleClick(item, "listing")
                        }
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </SectionWrapper>
          )}
        </div>
      </section>
    </>
  );
};

export default SingleBannerTree;

/* ------- helpers from your file (same) ------- */



const buildSafeSearch = (location) => {
  const current = new URLSearchParams(location?.search);
  const next = new URLSearchParams();

  keepKeys.forEach((k) => {
    const v = current.get(k);
    if (v !== null && v !== "") next.set(k, v);
  });

  return next.toString() ? `?${next.toString()}` : "";
};

const SectionWrapper = ({
  title,
  children,
  viewMoreLink,
  location,
  className,
}) => {
  return (
    <section className={`text-left ${className}`}>
      {title ? (
        <div className="text-center pt-6 mb-4">
          <h2 className="text-2xl sm:text-3xl font-medium text-[#9d2e43]">
            {title}
          </h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto mt-3 rounded-full"></div>
        </div>
      ) : (
        <div className=" hidden lg:block text-center">
          <div className="mt-3  h-1"></div>
        </div>
      )}

      <div className="text-left h-full">{children}</div>

      {viewMoreLink && (
        <div className="mt-8 flex justify-center">
          <NavLink
            to={{ pathname: viewMoreLink, search: buildSafeSearch(location) }}
            className="group inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-orange-500 text-orange-600 font-semibold transition-all duration-300 hover:bg-orange-500 hover:text-white hover:shadow-lg hover:-translate-y-[1px]"
          >
            View More
            <span className="transition-transform group-hover:translate-x-1">
              →
            </span>
          </NavLink>
        </div>
      )}
    </section>
  );
};
